<template>
    <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path
            d="M7.45898 11.9974C7.60157 11.7504 7.958 11.7504 8.10059 11.9974L13.5547 21.4437C13.6973 21.6906 13.5186 21.9993 13.2334 21.9993H2.3252C2.04024 21.999 1.86236 21.6905 2.00488 21.4437L7.45898 11.9974Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.74092" />
        <path
            d="M7.45898 0.555969C7.60157 0.308996 7.958 0.308996 8.10059 0.555969L13.5547 10.0023C13.6973 10.2492 13.5186 10.5579 13.2334 10.5579H2.3252C2.04024 10.5576 1.86236 10.2491 2.00488 10.0023L7.45898 0.555969Z"
            fill="currentColor"
            stroke="currentColor"
            stroke-width="0.74092" />
    </svg>
</template>
